import {
  addLeadDivisionId,
  addLeadLocationTypeId,
  addLeadPhoneNumber,
  addLeadAltPhoneNumber,
} from '@user/components/Settings/EntityFormSettings'
import { FieldNames } from './FieldNames'

export const defaultFieldNames: FieldNames = {
  locationTypeId: addLeadLocationTypeId,
  divisionId: addLeadDivisionId,
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  firstName: 'firstName',
  lastName: 'lastName',
  company: 'company',
  phone: addLeadPhoneNumber,
  altPhone: addLeadAltPhoneNumber,
  phoneExt: 'phoneExt',
  altPhoneExt: 'altPhoneExt',
  emailAddresses: 'emailAddresses',
  externalLocationId: 'externalLocationId',
  fullAddress: 'fullAddress',
  nameGroup: 'nameGroup',
}
